import { Button, BUTTON_SIZE, BUTTON_TYPE } from '../../../../global/Button';
import { getNextButtonStyles } from '../../../../utils/tbbRegistration';
import './ProgressButton.scss';

const ProgressButton = ({
  onSubmit,
  storeConfig,
  stepTrackerProps,
  counter,
  name,
}) => (
  <div className="ProgressButton__container">
    <Button
      type={BUTTON_TYPE.QUATERNARY}
      size={BUTTON_SIZE.LARGE}
      onClick={onSubmit}
      style={getNextButtonStyles(storeConfig)}
      trackerProps={stepTrackerProps}
      progress={counter}
    >
      {name}
    </Button>
  </div>
);

export default ProgressButton;
